import { render, staticRenderFns } from "./ProjectEditComponent.vue?vue&type=template&id=620e8e3d"
import script from "./ProjectEditComponent.vue?vue&type=script&lang=js"
export * from "./ProjectEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports